import { FaWhatsapp } from "react-icons/fa";
import "../App.css";

export default function FloatingWhatsApp() {
  return (
    <a
      href="https://wa.me/918056064224" // Replace with your number
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
    >
      <FaWhatsapp className="whatsapp-icon" />
    </a>
  );
}